// src/components/ui/theme.js

import { COLORS } from '../../constants';

export const UI_FONT = 'Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif';

const SIZE = {
  sm: { padding: '7px 14px', fontSize: 12, borderRadius: 10 },
  md: { padding: '10px 20px', fontSize: 13, borderRadius: 12 },
};

export function getButtonStyle(variant = 'primary', options = {}) {
  const { size = 'md', refreshing = false, disabled = false, active = false } = options;
  const isDisabled = disabled || refreshing;
  const metrics = SIZE[size] || SIZE.md;

  const base = {
    fontFamily: UI_FONT,
    fontSize: metrics.fontSize,
    fontWeight: 700,
    lineHeight: 1.2,
    borderRadius: metrics.borderRadius,
    padding: metrics.padding,
    border: 'none',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    whiteSpace: 'nowrap',
    opacity: refreshing ? 0.85 : 1,
    transition: 'opacity 0.15s ease, box-shadow 0.15s ease',
    boxSizing: 'border-box',
  };

  const variants = {
    primary: {
      background: isDisabled ? '#94a3b8' : COLORS.gradientBlue,
      color: '#fff',
      boxShadow: isDisabled ? 'none' : '0 4px 14px rgba(52, 152, 219, 0.25)',
    },
    navy: {
      background: isDisabled ? '#94a3b8' : COLORS.navy,
      color: '#fff',
    },
    danger: {
      background: isDisabled ? COLORS.dangerLight : COLORS.danger,
      color: isDisabled ? COLORS.danger : '#fff',
    },
    dangerSoft: {
      background: COLORS.dangerLight,
      color: COLORS.danger,
      border: `1px solid ${COLORS.line}`,
    },
    outline: {
      background: isDisabled ? '#f1f5f9' : '#fff',
      color: isDisabled ? COLORS.muted : COLORS.navy,
      border: `1px solid ${COLORS.line}`,
    },
    outlineActive: {
      background: active && !isDisabled ? COLORS.navy : isDisabled ? '#f1f5f9' : '#fff',
      color: active && !isDisabled ? '#fff' : isDisabled ? COLORS.muted : COLORS.navy,
      border: `1px solid ${COLORS.line}`,
    },
    success: {
      background: isDisabled ? '#94a3b8' : COLORS.success,
      color: '#fff',
    },
    ghost: {
      background: '#fff',
      color: COLORS.danger,
      border: `1px solid ${COLORS.line}`,
    },
  };

  return { ...base, ...(variants[variant] || variants.primary) };
}

export const SPIN_KEYFRAMES = `
  @keyframes ui-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;
